import React, { useState } from "react";
import styled from "styled-components";
import "../App.css";
import Burguer from "./burguer";
import { HashLink as Link } from 'react-router-hash-link';

const Navigation = () => {
  const [NavColor, setNavColor] = useState(false);
  const [burguerButton, setBurguerButton] = useState(false);

  const navChange = () => {
    if (window.scrollY >= 20) {
      setNavColor(true);
    } else {
      setNavColor(false);
    }
  };

  const burguerChange = () => {
    if (burguerButton === true) {
      setBurguerButton(false);
    } else {
      setBurguerButton(true);
    }
  };
  window.addEventListener("scroll", navChange);
  return (
    <Nav className={NavColor ? "navbar active" : "navbar"}>
      <h2 className="tituloNav">Joaquin Varela</h2>
      <button onClick={burguerChange}>
        <Burguer />
      </button>
      <nav className={burguerButton ? "menu in" : "menu out"}>
        <ul >
          <li onClick={burguerChange}>
            <Link smooth to="/#About">About Me</Link>
          </li>
          <li onClick={burguerChange}>
            <Link smooth to="/#Work">Work</Link>
          </li>
          <li onClick={burguerChange}>
            <Link smooth to="/#skills">Skills</Link>
          </li>
        </ul>
      </nav>
    </Nav>
  );
};
export default Navigation;

const Nav = styled.div`
  background: transparent!important;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    background: transparent;
    border: none;
    outline: none;
    z-index: 10;
  }
  ul li a {
    display: flex;
    justify-content: space-around;
    margin-right: 1rem;
    color: white;
  }
  ul {
    display: flex;
    margin: 0;
  }

  @media (max-width: 768px) {
    nav {
      position: absolute;
      left: -1000;
    }
  }
`;
